import React from 'react';
import * as typeformEmbed from '@typeform/embed'

import Header from 'APP_ROOT/components/common/header/header';
import Footer from 'APP_ROOT/components/common/footer';

export default class Install extends React.PureComponent {
    typeformRef = React.createRef();

    componentDidMount() {
        typeformEmbed.makeWidget(this.typeformRef.current, 'https://form.typeform.com/to/sUP19keb', {
            hideFooter: true,
            hideHeaders: true,
            opacity: 0,
        });
    }

    render() {
        const childProps = {
            features: {
                logo_url: 'vendor_telus-logo'
            }
        };
        return (
            <div className="install-page">
            <Header {...childProps} />
            <div id="typeformEmbed" ref={this.typeformRef}></div>
            <Footer />
            </div>
        );
    }
}
